import { render } from "./SetPasswordForm.vue?vue&type=template&id=80a7d656&scoped=true&ts=true"
import script from "./SetPasswordForm.vue?vue&type=script&lang=ts"
export * from "./SetPasswordForm.vue?vue&type=script&lang=ts"

import "./SetPasswordForm.vue?vue&type=style&index=0&id=80a7d656&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80a7d656"]])

export default __exports__